import { CommonModule, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AutoFocusModule } from '@app/infrastructure/directives/auto-focus/auto-focus.module';
import { PresenterModeModule } from '@shared/directives/presenter-mode/presenter-mode.module';
import { PipesModule } from '@shared/pipes/pipes.module';

// External libs
// Lottie for animations
import player from 'lottie-web';
import { LottieModule } from 'ngx-lottie';
// Core UI
// Drag & Drop
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AppBreadcrumbModule, AppFooterModule, AppHeaderModule, AppSidebarModule } from '@coreui/angular';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { SearchFilterComponent } from '@shared/filters/search-filter/search-filter.component';
// Pipes
import { TableColumnsConfigComponent } from '@shared/table-columns-config/table-columns-config.component';
// ngx-bootstrap & ng-bootstrap & ngx-datatable & multiselect
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
// Chart
import { ChartsModule, ThemeService } from 'ng2-charts';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxEchartsModule } from 'ngx-echarts';
import * as echarts from 'echarts';
// Material
import { AngularMaterialModule } from './angular-material.module';
// Components
import { SimpleKpiComponent } from './components/simple-kpi/simple-kpi.component';
import { StepperContainerComponent } from './components/stepper-container/stepper-container.component';
import { StepperComponent } from './components/stepper/stepper.component';
import { TableFilterComponent } from './components/table-filter/table-filter.component';
// Directives
import { ClickOutsideDirective } from './directives/click-outside/click-outside.directive';
import { ForbiddenNameValidatorDirective } from './directives/forbidden-name-validator/forbidden-name-validator.directive';
import { ModalItemComponent } from '@modules/shared/components/modal-item/modal-item.component';
import { CounterModule } from '@app/components/counter/counter.module';
import { CircleInfoTooltipModule } from '@app/infrastructure/tooltips/circle-info-tooltip/circle-info-tooltip.module';

export function playerFactory() {
	return player;
}

@NgModule({
	declarations: [
		// Directives
		ClickOutsideDirective,
		ForbiddenNameValidatorDirective,
		// Components
		SimpleKpiComponent,
		SearchFilterComponent,
		TableColumnsConfigComponent,
		TableFilterComponent,
		StepperComponent,
		StepperContainerComponent,
		ModalItemComponent,
	],
	providers: [
		// Services
		ThemeService,
		// Pipes
		DecimalPipe,
	],
	imports: [
		// Angular
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule,
		// Chart
		ChartsModule,
		NgxEchartsModule.forRoot({
			echarts,
		}),
		// ngx-bootstrap & ng-bootstrap
		TooltipModule.forRoot(),
		TabsModule,
		ModalModule,
		NgbDropdownModule,
		NgxDatatableModule,
		NgMultiSelectDropDownModule,
		ButtonsModule,
		CollapseModule,
		BsDropdownModule,
		// Lottie
		LottieModule.forRoot({
			player: playerFactory,
		}),
		// Material
		AngularMaterialModule,
		// Core UI
		AppBreadcrumbModule,
		AppHeaderModule,
		AppFooterModule,
		AppSidebarModule,
		// Drag & Drop
		DragDropModule,
		PresenterModeModule,
		PipesModule,
		CounterModule,
		CircleInfoTooltipModule,
		AutoFocusModule,
	],
	exports: [
		// Angular
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		// Chart
		ChartsModule,
		NgxEchartsModule,
		// ngx-bootstrap & ng-bootstrap
		TooltipModule,
		TabsModule,
		ModalModule,
		NgbDropdownModule,
		NgxDatatableModule,
		NgMultiSelectDropDownModule,
		ButtonsModule,
		CollapseModule,
		BsDropdownModule,
		// Drag & Drop
		DragDropModule,
		// Lottie
		LottieModule,
		// Material
		AngularMaterialModule,
		// Core UI
		AppBreadcrumbModule,
		AppHeaderModule,
		AppFooterModule,
		AppSidebarModule,
		// Components
		SimpleKpiComponent,
		SearchFilterComponent,
		TableColumnsConfigComponent,
		TableFilterComponent,
		StepperComponent,
		StepperContainerComponent,
		ModalItemComponent,
		// Pipes
		DecimalPipe,
		// Directives
		ClickOutsideDirective,
		ForbiddenNameValidatorDirective,
	],
})
export class SharedModule {}
